import { urlPatterns } from '@pm2/sitemap-utils';
import { guardChildNodeByType, xml2ast, paragraphHtmlParsers, simpleHtmlParsers } from '@utils/ast';
import { decodeHtmlEntities } from '@utils/common';
import { parseCaption } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseCtaComponent = (node) => {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  const cardsContainer = Array.from(node.childNodes).find(
    guardChildNodeByType("CallToActionCards")
  );
  if (!cardsContainer || !pm2) {
    return null;
  }
  const cards = Array.from(cardsContainer.children).map((it) => parseCtaCard(it)).filter((it) => it !== null);
  if (cards.length === 0) {
    return null;
  }
  pm2.learningObjectId ??= node.getAttribute("id") ?? void 0;
  pm2.learningObjectTitle ??= node.getAttribute("title") ?? void 0;
  return {
    nodeType: "cta-component",
    id: node.getAttribute("id") ?? void 0,
    pm2,
    meta: {
      title: node.getAttribute("title") ?? void 0,
      columnCount: (() => {
        switch (node.getAttribute("numberOfColumns")) {
          case "1":
            return 1;
          case "2":
            return 2;
          case "3":
            return 3;
          case "4":
            return 4;
          default:
            return void 0;
        }
      })()
    },
    cards
  };
};
function parseCtaCard(node) {
  const description = node.getAttribute("description");
  const linkTarget = (() => {
    switch (node.getAttribute("linkTarget")) {
      case "LightBox":
        return "lightbox";
      case "Download":
        return "download";
      case "NewTab":
        return "new-tab";
      case "SameTab":
        return "same-tab";
      default:
        console.warn(
          "Unable to recognice LinkTarget for CtaComponentCard",
          node
        );
        return null;
    }
  })();
  if (linkTarget === null) {
    return null;
  }
  const colorVariant = (() => {
    switch (node.getAttribute("color")) {
      case "bokstype-1":
        return "type-1";
      case "bokstype-2":
        return "type-2";
      case "bokstype-3":
        return "type-3";
      default:
        return void 0;
    }
  })();
  const imageSrc = node.getAttribute("imageUrl");
  const href = (() => {
    switch (linkTarget) {
      case "download":
        return `${process.env["PM2_MEDIA_DOMAIN"]}${node.getAttribute(
          "downloadUrl"
        )}`;
      case "new-tab":
        return node.getAttribute("externalUrl") ?? "";
      case "lightbox":
        return urlPatterns.element(node.getAttribute("linkId") ?? "") ?? "";
      case "same-tab":
      default:
        switch (node.getAttribute("linkTemplate")) {
          case "ResourcePage":
          case "Resource":
            return `${node.getAttribute(
              "linkShortPath"
            )}?resource=${node.getAttribute("linkId")}`;
          default:
            return node.getAttribute("linkShortPath") ?? "";
        }
    }
  })();
  return {
    title: node.getAttribute("title") ?? "",
    description: description ? xml2ast(
      decodeHtmlEntities(description),
      {
        ...simpleHtmlParsers,
        ...paragraphHtmlParsers
      },
      "text/html"
    ) : void 0,
    imageSrc: imageSrc ? `${process.env["PM2_MEDIA_DOMAIN"]}/${imageSrc}` : void 0,
    link: {
      id: node.getAttribute("linkId") ?? "",
      target: linkTarget,
      href
    },
    meta: {
      colorVariant
    }
  };
}
const ctaComponentParsers = {
  calltoactioncardcontainer: parseCtaComponent
};

export { ctaComponentParsers };
//# sourceMappingURL=component.cta.js.map
